export const CNavigationLogoClaim = {
  text: 'Book to Guide',
}
